import { useSyncExternalStore } from 'react'
import type {
  Appointment,
  AppointmentStatus,
  AppNotification,
  Barber,
  BlockedSlot,
  ClientRecord,
  ClientUser,
  Promotion,
  Service,
  ShopConfig,
} from './types'

// --- SEED DATA ---
const SEED_SERVICES: Service[] = [
  {
    id: 's1',
    name: 'Corte clásico',
    duration: '30 min',
    price: 450,
    desc: 'Corte a tijera o máquina, lavado y peinado.',
    category: 'Corte',
  },
  {
    id: 's2',
    name: 'Corte Fade',
    duration: '45 min',
    price: 550,
    desc: 'Degradado de precisión con acabado profesional.',
    category: 'Corte',
  },
  {
    id: 's3',
    name: 'Corte Premium',
    duration: '45 min',
    price: 650,
    desc: 'Corte a medida con asesoría de estilo y productos premium.',
    category: 'Corte',
  },
  {
    id: 's4',
    name: 'Solo barba',
    duration: '20 min',
    price: 250,
    desc: 'Recorte y arreglo de barba con máquina y navaja.',
    category: 'Barba',
  },
  {
    id: 's5',
    name: 'Perfilado de barba',
    duration: '30 min',
    price: 350,
    desc: 'Diseño de barba con navaja, toalla caliente y aceites esenciales.',
    category: 'Barba',
  },
  {
    id: 's6',
    name: 'Corte + Barba',
    duration: '60 min',
    price: 700,
    desc: 'La combinación clásica. Corte completo y arreglo de barba.',
    category: 'Combo',
  },
  {
    id: 's7',
    name: 'Corte + Barba + Cejas',
    duration: '75 min',
    price: 850,
    desc: 'La experiencia completa, incluye perfilado de cejas.',
    category: 'Combo',
  },
  {
    id: 's8',
    name: 'Lavado + Peinado',
    duration: '20 min',
    price: 250,
    desc: 'Lavado con masaje capilar y peinado con producto.',
    category: 'Extra',
  },
  {
    id: 's9',
    name: 'Tratamiento capilar',
    duration: '45 min',
    price: 650,
    desc: 'Tratamiento nutritivo e hidratante para el cabello.',
    category: 'Tratamiento',
  },
  {
    id: 's10',
    name: 'Coloración',
    duration: '90 min',
    price: 900,
    desc: 'Tintura profesional con acabado uniforme.',
    category: 'Color',
  },
  {
    id: 's11',
    name: 'Mechas',
    duration: '180 min',
    price: 1600,
    desc: 'Mechas y reflejos personalizados.',
    category: 'Color',
  },
  {
    id: 's12',
    name: 'Platinado',
    duration: '240 min',
    price: 2200,
    desc: 'Decoloración total y matización platino.',
    category: 'Color',
  },
  {
    id: 's13',
    name: 'Afeitado clásico',
    duration: '30 min',
    price: 450,
    desc: 'Afeitado a navaja con toalla caliente y ritual completo.',
    category: 'Barba',
  },
  {
    id: 's14',
    name: 'Servicio VIP',
    duration: '120 min',
    price: 950,
    desc: 'Experiencia premium: corte, barba, tratamiento y bebida de cortesía.',
    category: 'Premium',
  },
]

const SEED_BARBERS: Barber[] = [
  {
    id: 'b1',
    name: 'Juan Pérez',
    role: 'Fade Expert',
    image:
      'https://cdn.magicpatterns.com/uploads/mk5ijbZLMys6EvKwzSSvZe/Captura_de_pantalla_2026-07-04_182410.png',
    rating: 4.9,
    reviews: 128,
    experience: 8,
    specialties: ['Fades', 'Degradados', 'Diseños'],
    avgTime: '35 min',
    bio: 'Especialista en degradados, diseños y estilos modernos. Apasionado por el detalle y la precisión.',
    gallery: [
      'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?auto=format&fit=crop&q=80&w=300',
      'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&q=80&w=300',
      'https://images.unsplash.com/photo-1521490878406-4d4f45c2e91d?auto=format&fit=crop&q=80&w=300',
    ],
    serviceIds: ['s1', 's2', 's3', 's6', 's7', 's14'],
    priceFrom: 450,
    reviewList: [
      {
        id: 'r1',
        author: 'Nicolás',
        rating: 5,
        text: 'El mejor fade que me hicieron. Crack total.',
        date: '2026-06-20',
      },
      {
        id: 'r2',
        author: 'Franco',
        rating: 5,
        text: 'Puntual y prolijo. Recomendadísimo.',
        date: '2026-06-10',
      },
    ],
  },
  {
    id: 'b2',
    name: 'Matías Silva',
    role: 'Barba Master',
    image:
      'https://cdn.magicpatterns.com/uploads/dHQwgAnvFV18tNNG3iqzLh/Captura_de_pantalla_2026-07-04_182441.png',
    rating: 4.8,
    reviews: 89,
    experience: 6,
    specialties: ['Barba', 'Perfilado', 'Afeitado clásico'],
    avgTime: '30 min',
    bio: 'Maestro de la barba. Toalla caliente, navaja y el mejor cuidado facial de la ciudad.',
    gallery: [
      'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?auto=format&fit=crop&q=80&w=300',
      'https://images.unsplash.com/photo-1585747860715-2ba37e788b70?auto=format&fit=crop&q=80&w=300',
    ],
    serviceIds: ['s4', 's5', 's6', 's7', 's13'],
    priceFrom: 250,
    reviewList: [
      {
        id: 'r3',
        author: 'Lucas',
        rating: 5,
        text: 'Me dejó la barba impecable.',
        date: '2026-06-18',
      },
    ],
  },
  {
    id: 'b3',
    name: 'Lucas Torres',
    role: 'Estilo Clásico',
    image:
      'https://cdn.magicpatterns.com/uploads/1AsGw8nSYng3MK8G2AYNdR/Captura_de_pantalla_2026-07-04_182451.png',
    rating: 4.9,
    reviews: 210,
    experience: 12,
    specialties: ['Corte clásico', 'Color', 'Tijera'],
    avgTime: '40 min',
    bio: 'Doce años de experiencia. Referente del corte clásico y la coloración.',
    gallery: [
      'https://images.unsplash.com/photo-1512690459411-b9245aed614b?auto=format&fit=crop&q=80&w=300',
      'https://images.unsplash.com/photo-1567894340315-735d7c361db0?auto=format&fit=crop&q=80&w=300',
    ],
    serviceIds: ['s1', 's3', 's8', 's9', 's10', 's11', 's12'],
    priceFrom: 450,
    reviewList: [
      {
        id: 'r4',
        author: 'Diego',
        rating: 5,
        text: 'Un maestro. Sabe lo que hace.',
        date: '2026-06-15',
      },
    ],
  },
]

const SEED_PROMOTIONS: Promotion[] = [
  {
    id: 'p1',
    title: '20% OFF',
    subtitle: 'Lunes y martes',
    discount: '20%',
    color: '#C8A548',
  },
  {
    id: 'p2',
    title: 'Happy Hour',
    subtitle: 'Cortes de 15 a 17 hs',
    discount: '15%',
    color: '#4A90D9',
  },
]

const SEED_NOTIFICATIONS: AppNotification[] = [
  {
    id: 'n1',
    type: 'reminder',
    title: 'Recordatorio de turno',
    body: 'Tenés un turno mañana a las 10:00 con Juan Pérez.',
    date: '2026-07-03',
    read: false,
  },
  {
    id: 'n2',
    type: 'promo',
    title: '20% OFF esta semana',
    body: 'Aprovechá el descuento de lunes y martes.',
    date: '2026-07-01',
    read: false,
  },
  {
    id: 'n3',
    type: 'news',
    title: 'Nuevo barbero en el equipo',
    body: 'Sumamos a Lucas Torres, especialista en color.',
    date: '2026-06-28',
    read: true,
  },
  {
    id: 'n4',
    type: 'schedule',
    title: 'Cambio de horario',
    body: 'El sábado abrimos de 10 a 18 hs.',
    date: '2026-06-25',
    read: true,
  },
]

const DEFAULT_CONFIG: ShopConfig = {
  shopName: 'BARBEROS',
  address: 'Av. del Libertador 1234, Palermo, Buenos Aires',
  phone: '+54 11 1234-5678',
  email: 'hola@barberos.com',
  instagram: '@barberos.ar',
  facebook: 'BarberOS',
  tiktok: '@barberos',
  whatsapp: '+54 11 1234-5678',
  mercadoPagoAlias: 'barberos.mp',
  openHour: 9,
  closeHour: 20,
  slotMinutes: 30,
  chatWelcome:
    'Hola 👋 Soy BarberOS Assistant. Puedo ayudarte a:\n• Reservar un turno\n• Explicarte la aplicación\n• Mostrar servicios\n• Resolver dudas\n\n¿Qué necesitás?',
}

const DEFAULT_USER: ClientUser = {
  name: 'Nicolás',
  lastName: 'Gómez',
  email: '',
  phone: '',
  isGuest: true,
  loggedIn: false,
}

// --- DEMO DATA (para poblar dashboard, gráficas y CRM del panel admin) ---
const DEMO_CLIENT_NAMES = [
  'Nicolás Gómez',
  'Franco Herrera',
  'Lucas Méndez',
  'Diego Fernández',
  'Martín Rossi',
  'Santiago Díaz',
  'Joaquín Vega',
  'Bruno Castro',
  'Federico Sosa',
  'Tomás Rivera',
  'Agustín Núñez',
  'Emiliano Paz',
  'Rodrigo Cabrera',
  'Ignacio Torres',
  'Facundo Ledesma',
  'Mateo Ferreira',
]

const DEMO_CLIENT_STATUSES: ClientRecord['status'][] = [
  'VIP',
  'Frecuente',
  'Frecuente',
  'VIP',
  'Nuevo',
  'Frecuente',
  'Nuevo',
  'VIP',
  'Frecuente',
  'Nuevo',
  'Frecuente',
  'Nuevo',
  'Frecuente',
  'VIP',
  'Nuevo',
  'Frecuente',
]

function buildDemoClients(): ClientRecord[] {
  const base = Date.now()
  return DEMO_CLIENT_NAMES.map((name, i) => {
    const first = name.split(' ')[0].toLowerCase()
    return {
      id: `demo_c_${i + 1}`,
      name,
      phone: `+54 11 ${4000 + i}-${1000 + i * 37}`,
      email: `${first}@mail.com`,
      status: DEMO_CLIENT_STATUSES[i],
      notes:
        i % 4 === 0
          ? 'Prefiere turnos por la tarde.'
          : i % 3 === 0
            ? 'Cliente puntual, buen tipper.'
            : '',
      createdAt: new Date(base - (i + 1) * 86400000 * 3).toISOString(),
    }
  })
}

/**
 * Builds ~90 demo appointments spread across the last 30 days plus a handful
 * of upcoming ones, so the admin dashboard KPIs, income area chart and
 * booking volume bar chart render with realistic data out of the box.
 */
function buildDemoAppointments(
  barbers: Barber[],
  services: Service[],
): Appointment[] {
  const appts: Appointment[] = []
  const now = new Date()
  const clients = DEMO_CLIENT_NAMES
  const times = ['10:00', '11:30', '13:00', '15:30', '17:00', '18:30', '19:30']
  const methods = ['Mercado Pago', 'Tarjeta', 'Efectivo']
  let counter = 0
  const pick = <T,>(arr: T[], seed: number) => arr[seed % arr.length]

  // Past 30 days — 2 to 5 appointments per day
  for (let dayOffset = 30; dayOffset >= 1; dayOffset--) {
    const d = new Date(now)
    d.setDate(d.getDate() - dayOffset)
    const dow = d.getDay()
    // busier on weekends (Fri/Sat), quieter Sundays
    const perDay =
      dow === 0 ? 2 : dow === 5 || dow === 6 ? 4 + (dayOffset % 2) : 3
    const dateStr = d.toISOString().slice(0, 10)
    for (let j = 0; j < perDay; j++) {
      const barber = pick(barbers, counter + j)
      const service = pick(services, counter * 2 + j)
      const client = pick(clients, counter + j * 3)
      // ~12% cancelled, of the rest ~90% approved else pending
      const roll = (counter * 7 + j * 3) % 100
      const status: AppointmentStatus = roll < 12 ? 'cancelled' : 'completed'
      const paymentStatus: PaymentStatus =
        status === 'cancelled' ? 'rejected' : roll < 20 ? 'pending' : 'approved'
      appts.push({
        id: `demo_a_${counter}_${j}`,
        barberId: barber.id,
        barberName: barber.name,
        barberImage: barber.image,
        serviceId: service.id,
        serviceName: service.name,
        price: service.price,
        date: dateStr,
        time: pick(times, counter + j),
        clientName: client,
        clientContact: `+54 11 ${4000 + ((counter + j) % 900)}-0000`,
        paymentStatus,
        status,
        createdAt: d.toISOString(),
        paymentMethod: pick(methods, counter + j),
      })
    }
    counter += perDay
  }

  // Today + upcoming week — confirmed/pending upcoming turns
  for (let dayOffset = 0; dayOffset <= 6; dayOffset++) {
    const d = new Date(now)
    d.setDate(d.getDate() + dayOffset)
    const dateStr = d.toISOString().slice(0, 10)
    const perDay = dayOffset === 0 ? 3 : 2
    for (let j = 0; j < perDay; j++) {
      const barber = pick(barbers, counter + j)
      const service = pick(services, counter + j * 2)
      const client = pick(clients, counter * 2 + j)
      appts.push({
        id: `demo_up_${counter}_${j}`,
        barberId: barber.id,
        barberName: barber.name,
        barberImage: barber.image,
        serviceId: service.id,
        serviceName: service.name,
        price: service.price,
        date: dateStr,
        time: pick(times, counter + j + 2),
        clientName: client,
        clientContact: `+54 11 ${5000 + ((counter + j) % 900)}-0000`,
        paymentStatus: (counter + j) % 3 === 0 ? 'pending' : 'approved',
        status: 'upcoming',
        createdAt: now.toISOString(),
        paymentMethod: pick(methods, counter + j),
      })
    }
    counter += perDay
  }

  return appts
}

// --- PERSISTENCE ---
const APPTS_KEY = 'barberos:appointments'
const BLOCKED_KEY = 'barberos:blocked'
const CONFIG_KEY = 'barberos:config'
const NOTIF_KEY = 'barberos:notifications'
const USER_KEY = 'barberos:user'
const ONBOARD_KEY = 'barberos:onboarded'
const BARBERS_KEY = 'barberos:barbers'
const SERVICES_KEY = 'barberos:services'
const PROMOS_KEY = 'barberos:promotions'
const CLIENTS_KEY = 'barberos:clients'

interface State {
  appointments: Appointment[]
  blocked: BlockedSlot[]
  config: ShopConfig
  notifications: AppNotification[]
  user: ClientUser
  onboarded: boolean
  barbers: Barber[]
  services: Service[]
  promotions: Promotion[]
  clients: ClientRecord[]
}

function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as T) : fallback
  } catch {
    return fallback
  }
}

const seededBarbers = read<Barber[]>(BARBERS_KEY, SEED_BARBERS)
const seededServices = read<Service[]>(SERVICES_KEY, SEED_SERVICES)

let state: State = {
  appointments: read<Appointment[]>(
    APPTS_KEY,
    buildDemoAppointments(seededBarbers, seededServices),
  ),
  blocked: read<BlockedSlot[]>(BLOCKED_KEY, []),
  config: { ...DEFAULT_CONFIG, ...read<Partial<ShopConfig>>(CONFIG_KEY, {}) },
  notifications: read<AppNotification[]>(NOTIF_KEY, SEED_NOTIFICATIONS),
  user: { ...DEFAULT_USER, ...read<Partial<ClientUser>>(USER_KEY, {}) },
  onboarded: read<boolean>(ONBOARD_KEY, false),
  barbers: seededBarbers,
  services: seededServices,
  promotions: read<Promotion[]>(PROMOS_KEY, SEED_PROMOTIONS),
  clients: read<ClientRecord[]>(CLIENTS_KEY, buildDemoClients()),
}

const listeners = new Set<() => void>()

function emit() {
  state = { ...state }
  listeners.forEach((l) => l())
}

function persist() {
  try {
    localStorage.setItem(APPTS_KEY, JSON.stringify(state.appointments))
    localStorage.setItem(BLOCKED_KEY, JSON.stringify(state.blocked))
    localStorage.setItem(CONFIG_KEY, JSON.stringify(state.config))
    localStorage.setItem(NOTIF_KEY, JSON.stringify(state.notifications))
    localStorage.setItem(USER_KEY, JSON.stringify(state.user))
    localStorage.setItem(ONBOARD_KEY, JSON.stringify(state.onboarded))
    localStorage.setItem(BARBERS_KEY, JSON.stringify(state.barbers))
    localStorage.setItem(SERVICES_KEY, JSON.stringify(state.services))
    localStorage.setItem(PROMOS_KEY, JSON.stringify(state.promotions))
    localStorage.setItem(CLIENTS_KEY, JSON.stringify(state.clients))
  } catch {
    /* ignore quota / private mode */
  }
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function getSnapshot() {
  return state
}

export function useStore() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}

// --- APPOINTMENT ACTIONS ---
export function addAppointment(appt: Appointment) {
  state.appointments = [...state.appointments, appt]
  persist()
  emit()
}

export function removeAppointment(id: string) {
  state.appointments = state.appointments.filter((a) => a.id !== id)
  persist()
  emit()
}

export function cancelAppointment(id: string) {
  state.appointments = state.appointments.map((a) =>
    a.id === id ? { ...a, status: 'cancelled' } : a,
  )
  persist()
  emit()
}

export function rescheduleAppointment(id: string, date: string, time: string) {
  state.appointments = state.appointments.map((a) =>
    a.id === id ? { ...a, date, time, status: 'upcoming' } : a,
  )
  persist()
  emit()
}

export function toggleBlockedSlot(
  barberId: string,
  date: string,
  time: string,
) {
  const existing = state.blocked.find(
    (b) => b.barberId === barberId && b.date === date && b.time === time,
  )
  if (existing) {
    state.blocked = state.blocked.filter((b) => b.id !== existing.id)
  } else {
    state.blocked = [
      ...state.blocked,
      { id: `blk_${Date.now()}`, barberId, date, time },
    ]
  }
  persist()
  emit()
}

// --- CONFIG / USER / NOTIFICATIONS ---
export function updateConfig(patch: Partial<ShopConfig>) {
  state.config = { ...state.config, ...patch }
  persist()
  emit()
}

export function updateUser(patch: Partial<ClientUser>) {
  state.user = { ...state.user, ...patch }
  persist()
  emit()
}

export function logoutClient() {
  state.user = { ...DEFAULT_USER }
  persist()
  emit()
}

export function completeOnboarding() {
  state.onboarded = true
  persist()
  emit()
}

export function markNotificationRead(id: string) {
  state.notifications = state.notifications.map((n) =>
    n.id === id ? { ...n, read: true } : n,
  )
  persist()
  emit()
}

export function markAllNotificationsRead() {
  state.notifications = state.notifications.map((n) => ({ ...n, read: true }))
  persist()
  emit()
}

// --- CRUD ACTIONS ---
export function addBarber(barber: Barber) {
  state.barbers = [...state.barbers, barber]
  persist()
  emit()
}
export function updateBarber(id: string, patch: Partial<Barber>) {
  state.barbers = state.barbers.map((b) =>
    b.id === id ? { ...b, ...patch } : b,
  )
  persist()
  emit()
}
export function removeBarber(id: string) {
  state.barbers = state.barbers.filter((b) => b.id !== id)
  persist()
  emit()
}

export function addService(service: Service) {
  state.services = [...state.services, service]
  persist()
  emit()
}
export function updateService(id: string, patch: Partial<Service>) {
  state.services = state.services.map((s) =>
    s.id === id ? { ...s, ...patch } : s,
  )
  persist()
  emit()
}
export function removeService(id: string) {
  state.services = state.services.filter((s) => s.id !== id)
  persist()
  emit()
}

export function addPromotion(promo: Promotion) {
  state.promotions = [...state.promotions, promo]
  persist()
  emit()
}
export function updatePromotion(id: string, patch: Partial<Promotion>) {
  state.promotions = state.promotions.map((p) =>
    p.id === id ? { ...p, ...patch } : p,
  )
  persist()
  emit()
}
export function removePromotion(id: string) {
  state.promotions = state.promotions.filter((p) => p.id !== id)
  persist()
  emit()
}

export function addClient(client: ClientRecord) {
  state.clients = [...state.clients, client]
  persist()
  emit()
}
export function updateClient(id: string, patch: Partial<ClientRecord>) {
  state.clients = state.clients.map((c) =>
    c.id === id ? { ...c, ...patch } : c,
  )
  persist()
  emit()
}
export function removeClient(id: string) {
  state.clients = state.clients.filter((c) => c.id !== id)
  persist()
  emit()
}

// --- SELECTORS / HELPERS ---
export function isSlotTaken(
  appointments: Appointment[],
  blocked: BlockedSlot[],
  barberId: string,
  date: string,
  time: string,
): boolean {
  const takenByAppt = appointments.some(
    (a) =>
      a.barberId === barberId &&
      a.date === date &&
      a.time === time &&
      a.status !== 'cancelled' &&
      a.paymentStatus === 'approved',
  )
  const isBlocked = blocked.some(
    (b) => b.barberId === barberId && b.date === date && b.time === time,
  )
  return takenByAppt || isBlocked
}

export function buildTimeSlots(config: ShopConfig): string[] {
  const slots: string[] = []
  const step = config.slotMinutes
  for (let m = config.openHour * 60; m <= config.closeHour * 60; m += step) {
    const h = Math.floor(m / 60)
    const min = m % 60
    slots.push(`${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`)
  }
  return slots
}

/** Upcoming (not cancelled, date >= today) appointments sorted ascending */
export function getUpcoming(appointments: Appointment[]): Appointment[] {
  const today = new Date().toISOString().slice(0, 10)
  return appointments
    .filter((a) => a.status !== 'cancelled' && a.date >= today)
    .sort((a, b) => (a.date + a.time).localeCompare(b.date + b.time))
}

/** History: cancelled OR past appointments, most recent first */
export function getHistory(appointments: Appointment[]): Appointment[] {
  const today = new Date().toISOString().slice(0, 10)
  return appointments
    .filter((a) => a.status === 'cancelled' || a.date < today)
    .sort((a, b) => (b.date + b.time).localeCompare(a.date + a.time))
}

export function getBarber(id: string): Barber | undefined {
  return state.barbers.find((b) => b.id === id)
}

/** Neutral branded placeholder used when a remote image fails to load */
export const IMG_FALLBACK =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><rect width="200" height="200" fill="#202020"/><g fill="none" stroke="#C8A548" stroke-width="6" opacity="0.5"><circle cx="80" cy="140" r="14"/><circle cx="120" cy="140" r="14"/><path d="M92 132 L128 70" stroke-linecap="round"/><path d="M108 132 L72 70" stroke-linecap="round"/></g></svg>`,
  )

/** onError handler: swaps a broken image for the branded placeholder once */
export function handleImgError(e: { currentTarget: HTMLImageElement }): void {
  const img = e.currentTarget
  if (img.src !== IMG_FALLBACK) {
    img.onerror = null
    img.src = IMG_FALLBACK
  }
}

export function getService(id: string): Service | undefined {
  return state.services.find((s) => s.id === id)
}
